module.exports = __webpack_public_path__ + "static/img/section7_content1_bg1.bb6c135b.png";